import { render, staticRenderFns } from "./InventoryPlanning.vue?vue&type=template&id=bfcec210&"
import script from "./InventoryPlanning.vue?vue&type=script&lang=js&"
export * from "./InventoryPlanning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports